import { Card, Layout } from "antd";
import styled from "styled-components";
import AppScrollbar from "@nxsys/components/AppScrollbar";

export const StyledAuthWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledAuthCard = styled(Card)`
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
  position: relative;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;

  & .ant-card-body {
    padding: 0;
    display: flex;
    flex: 1;
  }
`;

export const StyledAuthMainContent = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media screen and (min-width: ${({theme}) => theme.breakpoints.sm}px) {
    padding: 40px;
    width: 50%;
  }

  @media screen and (min-width: ${({theme}) => theme.breakpoints.lg}px) {
    width: 42%;
    padding: 48px 56px;
  }
`;

export const StyledAuthCardHeader = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: ${({theme}) => theme.breakpoints.md}px) {
    margin-bottom: 36px;
  }

  & img {
    cursor: pointer;
    height: 36px;
    margin-right: 10px;

    [dir='rtl'] & {
      margin-right: 0;
      margin-left: 10px;
    }
  }
`;

export const StyledAuthWellAction = styled.div`
  position: relative;
  padding: 24px;
  display: none;
  background: linear-gradient(135deg, ${({theme}) => theme.palette.primary.main} 0%, ${({theme}) => theme.palette.gray[900]} 100%);
  color: white;
  font-size: ${({theme}) => theme.font.size.base};
  width: 100%;

  @media screen and (min-width: ${({theme}) => theme.breakpoints.sm}px) {
    padding: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 50%;
    border-radius: 0;
  }

  @media screen and (min-width: ${({theme}) => theme.breakpoints.lg}px) {
    width: 58%;
    padding: 48px;
  }

  & h2 {
    color: white;
    font-size: 32px;
    font-weight: ${({theme}) => theme.font.weight.bold};
    margin-bottom: 12px;
  }

  & p {
    line-height: 1.7;
    opacity: 0.85;
    font-size: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledAuthWelContent = styled.div`
  max-width: 320px;
`;

export const StyledAuth = styled(Layout)`
  flex: 1;
  display: flex;
  position: relative;
  min-height: 100vh;
  width: 100vw;

  & .ant-layout-content {
    padding: 0;
    display: flex;
  }

  & .main-auth-scrollbar {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  & .footer {
    margin-right: 0;
    margin-left: 0;
  }
`;

export const StyledMainAuthScrollbar = styled(AppScrollbar)`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
